import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import typesUsers from '../api/typesUsers';
import type { UserType } from '../types';
import type { ApiError } from "@/types/apiResponse";

export const useTypesUsers = (): UseQueryResult<UserType[], ApiError> => {
  return useQuery({
    queryKey: ['typesUsers'],
    queryFn: async () => {
      const response = await typesUsers();
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutos de datos "frescos"
  });
};
